import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Pages from './pages/Pages';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Pages />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
